import { SearchRefraction } from '@untitledui/icons';

import { Button } from '@/lib/base/buttons/button';

export default function NotFoundPage() {
  return (
    <div className='flex flex-1 items-center justify-center px-6 py-24'>
      <div className='flex flex-col items-center gap-6 text-center max-w-md'>
        <SearchRefraction
          className='text-[var(--color-text-secondary)]'
          size={48}
        />

        <div className='flex flex-col gap-2'>
          <h1 className='text-2xl font-semibold text-[var(--color-text-primary)]'>
            Page not found
          </h1>
          <p className='text-[var(--color-text-secondary)]'>
            This page doesn't exist or may have been moved.
          </p>
        </div>

        <div className='flex gap-3'>
          <Button color='secondary' onClick={() => window.history.back()}>
            Go back
          </Button>
          <Button color='primary' href='/'>
            Go home
          </Button>
        </div>
      </div>
    </div>
  );
}
